import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { Column, ColumnType } from 'src/app/models/model'

@Component({
  selector: 'app-pending-items-table',
  templateUrl: './pending-items-table.component.html',
  styleUrls: ['./pending-items-table.component.scss']
})
export class PendingItemsTableComponent {
  @Input() columns: Column[] = []
  @Input() data = []
  @Input() showSerielNumber = true
  @Input() routeTo = null
  columnType = ColumnType
  constructor() {}
}
